.trigger {
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  gap: var(--space-2);
  text-align: left;
  cursor: pointer;
}

.trigger[data-placeholder] {
  color: var(--color-fg-subtle);
}

.chevron {
  display: inline-flex;
  color: var(--color-fg-muted);
}

.chevron svg {
  width: var(--size-icon);
  height: var(--size-icon);
}

.content {
  max-height: var(--radix-select-content-available-height);
  min-width: var(--radix-select-trigger-width);
  overflow: hidden;
}
